import { Icon, Stack, Text } from '@backyard-ui/core';
import { LocationOutline } from '@backyard-ui/icons';

import { type Store } from '@/infra/services/catalog/store/model';

interface ItemProps {
  store: Store;
}

const Item = (props: Readonly<ItemProps>) => {
  const { store } = props;

  return (
    <Stack direction="column" spacing="6" data-testid="store-stock-item">
      <hr className="border-gray-500" />

      <Stack direction="column" spacing="2">
        <Stack spacing="2">
          <Icon>
            <LocationOutline />
          </Icon>

          <Text weight="bold">{store.name}</Text>
        </Stack>

        <Text size="sm" data-testid="item-stock">
          {store.stock ? (
            <>
              <strong>{store.stock}</strong> peças em estoque
            </>
          ) : (
            store.message
          )}
        </Text>

        <Text size="sm" data-testid="item-address">
          {store.address.street}, {store.address.number} - {store.address.cep} -{' '}
          {store.address.city}
        </Text>

        {store.pickupDisclaimer && (
          <div className="mr-2 rounded bg-gray-100 p-2">
            <Text size="sm" weight="bold" data-testid="item-disclaimer-header">
              {store.pickupDisclaimer.header}
            </Text>

            {store.pickupDisclaimer.body.map((disclaimer, index) => (
              <Text key={index} size="sm" data-testid="item-disclaimer-body">
                {disclaimer.replace('* ', '').replace('- ', '')}
              </Text>
            ))}
          </div>
        )}
      </Stack>
    </Stack>
  );
};

export default Item;
